// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1DmSG","list":"styles_list__1jMQE"};